// extracted by mini-css-extract-plugin
export default {"title":"DeliveryPage_title__U6wM3","item":"DeliveryPage_item__a5fy2","paymentItem":"DeliveryPage_paymentItem__nbmIK"};